import React from "react";
import { Check } from "lucide-react";
import { cx } from "components/crm/ui/uiUtils";

// Bordered checkbox row: one option of a list, orange tick.
const CheckRow = ({ checked, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={cx(
      "flex w-full items-center gap-3 rounded-xl border bg-white px-4 py-[15px] text-left text-sm font-medium leading-5 text-ink transition-colors",
      checked ? "border-primary" : "border-lineStrong hover:border-faint"
    )}
  >
    <span
      className={cx(
        "flex size-5 shrink-0 items-center justify-center rounded border",
        checked
          ? "border-primary bg-primary text-white"
          : "border-lineStrong bg-white"
      )}
    >
      {checked && <Check size={14} strokeWidth={3} />}
    </span>
    {children}
  </button>
);

export default CheckRow;
